<template>
  <div class="im-card-message" :class="{ right: isMe }" @click="onTap">
    <div class="content-list">
      <div class="content-item">
        <div class="subtitle-head">
          <div class="subtitle-h3">
            <span class="h3">{{ drugTitle(messageContext.prescripType) }}</span>
            <span v-if="messageContext.DrugList.length" class="intro">
              共{{ messageContext.drugCount }}种药品
            </span>
          </div>
        </div>
        <!-- 国际蒙医蒙药 -->
        <div v-if="['4', '7'].includes(messageContext.prescripType)" class="content">
          <kcMyShow
            :allInBool="messageContext.beacon"
            :drugList="messageContext.DrugList"
            :templateType="messageContext.templateType"
          />
        </div>
        <!-- 中药颗粒处方, 中药小包装, 中草药 -->
        <div v-else-if="['3', '5', '6'].includes(messageContext.prescripType)" class="content">
          <div class="txt">
            <span class="text">{{ zy() }}</span>
          </div>
        </div>
        <!-- 中成药处方 / 西药处方 ="item.prescripType === '1' || item.prescripType === '2'" -->
        <div v-else class="content">
          <div v-for="(txt, i) in messageContext.DrugList.slice(0, 2)" :key="i" class="txt">
            <span class="text">
              {{
                txt.drugName + '  x' + txt.amount + (txt.packageUnitValue || txt.packageUnit || '')
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { prescriptionCb } from '../../utils/timInit'
import kcMyShow from './kc-my-show.vue'
export default {
  name: 'imCustomPrescription',
  components: {
    kcMyShow
  },
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    },
    isMe() {
      return this.message.flow === 'out'
    }
  },
  methods: {
    getKeyValueText,
    onTap() {
      typeof prescriptionCb === 'function' && prescriptionCb(this.message)
    },
    drugTitle(type) {
      return getKeyValueText('prescrip_type', type) + '处方'
    },
    zy() {
      if (this.messageContext.DrugList.length) {
        return this.messageContext.DrugList.reduce((res, item) => {
          let str = `${item.drugName} ${item.useAuantity}${
            item.measureUnitValue || item.measureUnit
          } `
          if (item.drugDesc) {
            str += `（${getKeyValueText('prescrip_desc', item.drugDesc)}）`
          }
          res.push(str)
          return res
        }, []).join('，')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.im-card-message {
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
  background: #ffffff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .title-wrap {
      border-radius: 0.597333rem 0 0 0;
    }
  }

  .title-wrap {
    padding: 0.384rem 0.512rem;
    font-size: 0.64rem;
    line-height: 0.853333rem;
    color: #ffffff;
    background: #0089ff;
    border-radius: 0 0.597333rem 0 0;

    & > .text {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .content-list {
    padding: 0.256rem 0.512rem;

    .content-item {
      position: relative;

      .subtitle-head {
        padding-bottom: 0.256rem;
        border-bottom: 0.021333rem solid #ececec;
      }

      .subtitle {
        display: flex;
        align-items: center;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        padding-left: 0.213333rem;
        color: #222222;
        font-weight: 500;
        overflow: hidden;

        &::before {
          content: '';
          margin-right: 0.213333rem;
          display: block;
          width: 0.085333rem;
          height: 0.469333rem;
          border-radius: 0.053333rem;
          background: #0089ff;
        }

        & > .text {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .subtitle-h3 {
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        display: flex;
        align-items: center;
        overflow: hidden;

        .h3 {
          margin-right: 0.32rem;
          display: block;
          flex: 2;
          font-size: 0.64rem;
          line-height: 0.64rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          // overflow: hidden;
          text-align: left;
        }

        .intro {
          flex: 2;
          font-size: 0.597333rem;
          line-height: 0.64rem;
          color: #888888;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: right;
        }
      }

      .content {
        padding-top: 0.256rem;
        font-size: 0.64rem;
        line-height: 0.938667rem;
        color: #222222;

        .txt {
          padding-top: 0.256rem;
          padding-left: 0.298667rem;
          padding-bottom: 0.256rem;
          text-align: left;

          & > .text {
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
          }
        }

        .zy-txt {
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }
}
</style>
